import { CommunicationService } from './communication.service';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { UserInfo } from '../domains/common.domain';
import { LocalStorageService } from './local-storage.service';
import { TechnicianResponseData } from '../employee-overview/employee-overview.domain';
import { CommonService } from './common.service';
import { UserRoles } from '../constants/app.constants';

@Injectable()
export class UserService {
  private keys = {
    role: 'role',
    status: 'technician_status',
    technicianId: 'technician_id',
  };
  private readonly moderatorRoles = [UserRoles.administrator, UserRoles.employee];
  private readonly technicianRoles = [UserRoles.standardTechnician, UserRoles.guestTechnician];

  userDetails: UserInfo;
  updateUserData: Subject<UserInfo> = new Subject<UserInfo>();
  isMenuOpen = false;

  constructor(
    private localStorageService: LocalStorageService,
    private communicationService: CommunicationService,
    private commonService: CommonService
  ) {}

  get userLoginData(): UserInfo {
    return this.userDetails;
  }

  get userId(): number {
    return parseInt(this.localStorageService.getItem(this.keys.technicianId));
  }

  setUserData(userData: UserInfo, role: string, status: string): void {
    this.userDetails = userData;

    if (this.userDetails) {
      this.localStorageService.setItem(this.keys.status, status);
      this.localStorageService.setItem(this.keys.role, role);
    }

    this.updateUserData.next(this.userDetails);
  }

  getUserRole(): string {
    return this.localStorageService.getItem(this.keys.role);
  }

  getUserStatus(): string {
    return this.localStorageService.getItem(this.keys.status);
  }

  clearUserData() {
    this.setUserData(null, null, null);

    this.localStorageService.removeItem(this.keys.role);
    this.localStorageService.removeItem(this.keys.status);
  }

  reloadUserData(technicianId: number | string): Promise<void> {
    return new Promise((accept, reject) => {
      this.communicationService.getData<TechnicianResponseData>(`technician?technician_id=${technicianId.toString()}`).subscribe(
        technicianDataResponse => {
          const technicianData = (technicianDataResponse.technician && technicianDataResponse.technician[0]) || null;
          this.commonService.technicianData = technicianData;

          const userData: UserInfo = {
            status: technicianData && technicianData.status,
            technician_id: technicianId.toString(),
            user_email: technicianData && technicianData.email,
            role: technicianData && technicianData.role,
          };

          this.setUserData(userData, userData.role, userData.status);
          window.location.reload();
          accept();
        },
        error => {
          reject(error);
        }
      );
    });
  }

  public isUserModeratorRole(): boolean {
    const role = this.getUserRole();
    return this.moderatorRoles.some(m => m === role);
  }

  public isUserTechnicianRole(): boolean {
    const role = this.getUserRole();
    return this.technicianRoles.some(m => m === role);
  }

  public isUserCustomerRole(): boolean {
    const role = this.getUserRole();
    return UserRoles.customer === role;
  }

  public isUserVisitorRole(): boolean {
    const role = this.getUserRole();
    return UserRoles.observer === role;
  }

  public isChimneySweeper(): boolean {
    const role = this.getUserRole();
    return role === UserRoles.chimneySweeper;
  }
}
